import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export interface MultiSelectOption {
  value: string;
  label: string;
}

interface MultiSelectSearchProps {
  options: MultiSelectOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  label?: string;
  placeholder?: string;
  /**
   * Prefisso del `data-testid` di ogni voce, se serve un hook di test.
   *
   * Opzionale e senza effetto sul comportamento: le voci esistono comunque,
   * e un test che vuole asserirne l'**assenza** ha bisogno di poterle
   * nominare. Asserire sull'assenza e' il caso che conta — un campo che non
   * deve comparire non si verifica guardando cio' che c'e'.
   */
  testIdPrefix?: string;
}

const MultiSelectSearch: React.FC<MultiSelectSearchProps> = ({
  options,
  selected,
  onChange,
  label,
  placeholder,
  testIdPrefix,
}) => {
  const selectedOptions = options.filter((opt) => selected.includes(opt.value));

  const handleChange = (_: any, newValues: MultiSelectOption[]) => {
    onChange(newValues.map((opt) => opt.value));
  };

  return (
    <Autocomplete
      multiple
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={(option) => option.label}
      renderOption={
        testIdPrefix
          ? (props, option) => (
              <li {...props} data-testid={`${testIdPrefix}${option.value}`}>
                {option.label}
              </li>
            )
          : undefined
      }
      isOptionEqualToValue={(option, value) => option.value === value.value}
      ListboxProps={{
        sx: {
          maxHeight: "200px",
          overflowY: "auto",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          size="small"
        />
      )}
    />
  );
};

export default MultiSelectSearch;